// extracted by mini-css-extract-plugin
export default {"wrap":"Header_wrap__wUFY1","logo":"Header_logo__0oYsV","info":"Header_info__JT9tv"};